import React from 'react';
import PropTypes from 'prop-types';
import { SiteFooter } from 'bv-components';

import {
  Header,
  ContentsWrapper,
  BackboneHolder,
  LazySeo,
} from 'Index/features/layout/components';

import { Routing } from 'Index/features';

const CenterContentView = ({ loggedIn }) => (
  <div className="center-content">
    <Header loggedIn={loggedIn} />
    <ContentsWrapper loggedIn={loggedIn}>
      <Routing />
      <BackboneHolder />
      {!loggedIn && <LazySeo />}
      <SiteFooter />
    </ContentsWrapper>
  </div>
);

CenterContentView.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
};

export default CenterContentView;
